var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return Object.keys(_vm.emeaCableData).length > 0
    ? _c(
        "div",
        { staticClass: "row", attrs: { id: "mmy-row" } },
        [
          _c("div", { staticClass: "flex full-width" }, [
            _c(
              "div",
              { staticClass: "vehicle-input-title col xs-4 sm-4 md-6 lg-6" },
              [_vm._v(_vm._s(`${_vm.MMYType} ${_vm.index + 1}`))]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row full-width" },
              [
                _c("v-button", {
                  staticClass: "full-width",
                  attrs: {
                    position: "right",
                    mobile: "6",
                    tablet: "6",
                    desktop: "6",
                    styling: "tertiary",
                    disabled: false,
                    textAlign: "right",
                  },
                  on: { onClickEvent: _vm.removeRow },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "content",
                        fn: function () {
                          return [
                            _c("span", [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "14",
                                    height: "18",
                                    viewBox: "0 0 14 18",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1Z",
                                      fill: "#0D6EDE",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "underline" }, [
                                _vm._v(
                                  _vm._s(_vm.webstoreContent.cartPage.remove)
                                ),
                              ]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4115057167
                  ),
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("vSelect", {
            staticClass: "mmy-input",
            attrs: {
              placeholder: _vm.webstoreContent.cartPage.make,
              options: _vm.makes,
              value: _vm.row.make,
              id: `make_${_vm.index + 1}`,
            },
            on: {
              input: function ($event) {
                return _vm.setRowAttribute($event, "make")
              },
            },
          }),
          _vm._v(" "),
          _c("vSelect", {
            staticClass: "mmy-input",
            attrs: {
              placeholder: _vm.webstoreContent.cartPage.vehicle_type,
              options: _vm.vehicleTypes,
              label: "displayName",
              reduce: (displayName) => displayName.code,
              value: _vm.webstoreContent.cartPage[_vm.row.vehicleType],
              id: `vehicle_type_${_vm.index + 1}`,
            },
            on: {
              input: function ($event) {
                return _vm.setRowAttribute($event, "vehicleType")
              },
            },
          }),
          _vm._v(" "),
          _c("vSelect", {
            staticClass: "mmy-input",
            attrs: {
              placeholder: _vm.webstoreContent.cartPage.year,
              options: _vm.years,
              value: _vm.row.year,
              id: `year_${_vm.index + 1}`,
            },
            on: {
              input: function ($event) {
                return _vm.setRowAttribute($event, "year")
              },
            },
          }),
          _vm._v(" "),
          _vm.FMSGateway.length
            ? _c("vSelect", {
                staticClass: "mmy-input",
                attrs: {
                  placeholder: "FMS Gateway",
                  options: _vm.FMSGateway,
                  value: _vm.row.FMSGateway,
                  id: `FMS_Gateway_${_vm.index + 1}`,
                },
                on: {
                  input: function ($event) {
                    return _vm.setRowAttribute($event, "FMSGateway")
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.remoteTacho.length
            ? _c("vSelect", {
                staticClass: "mmy-input",
                attrs: {
                  placeholder: "Remote Tacho Download",
                  options: _vm.remoteTacho,
                  value: _vm.row.remoteTacho,
                  id: `remote_tacho_${_vm.index + 1}`,
                },
                on: {
                  input: function ($event) {
                    return _vm.setRowAttribute($event, "remoteTacho")
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.displayedQuantity,
                expression: "displayedQuantity",
              },
            ],
            staticClass: "mmy-quantity",
            attrs: {
              type: "number",
              placeholder: _vm.webstoreContent.cartPage.quantity,
              min: "0",
              id: `quantity_${_vm.index + 1}`,
            },
            domProps: { value: _vm.displayedQuantity },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.displayedQuantity = $event.target.value
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }